/** Impls dos use cases de Comunicação. @since H.4 */
import type {
  Aula, UpsertAulaCommand, ListAulasParams,
  MaterialApoio, UpsertMaterialApoioCommand, ListMateriaisParams,
  Manual, UpsertManualCommand, ListManuaisParams,
  Mensagem, EnviarMensagemCommand,
} from '@/domain/model/Comunicacao';
import type {
  AulaGateway, MaterialApoioGateway, ManualGateway, MensagemGateway,
} from '@/application/port/out/ComunicacaoGateways';
import type {
  ListAulasAoVivoUseCase, CreateAulaAoVivoUseCase, UpdateAulaAoVivoUseCase, ArquivarAulaAoVivoUseCase,
  ListMateriaisUseCase, CreateMaterialUseCase, UpdateMaterialUseCase, ArquivarMaterialUseCase,
  ListManuaisUseCase, CreateManualUseCase, UpdateManualUseCase, ArquivarManualUseCase,
  EnviarMensagemUseCase, ListMensagensByAlunoUseCase,
} from '@/application/port/in/ComunicacaoUseCase';

export class ListAulasAoVivo implements ListAulasAoVivoUseCase {
  constructor(private readonly g: AulaGateway) {}
  execute(p: ListAulasParams): Promise<Aula[]> { return this.g.list(p); }
}
export class CreateAulaAoVivo implements CreateAulaAoVivoUseCase {
  constructor(private readonly g: AulaGateway) {}
  execute(cmd: UpsertAulaCommand): Promise<Aula> { return this.g.create(cmd); }
}
export class UpdateAulaAoVivo implements UpdateAulaAoVivoUseCase {
  constructor(private readonly g: AulaGateway) {}
  execute(id: string, cmd: UpsertAulaCommand): Promise<Aula> { return this.g.update(id, cmd); }
}
export class ArquivarAulaAoVivo implements ArquivarAulaAoVivoUseCase {
  constructor(private readonly g: AulaGateway) {}
  execute(id: string): Promise<void> { return this.g.arquivar(id); }
}

export class ListMateriais implements ListMateriaisUseCase {
  constructor(private readonly g: MaterialApoioGateway) {}
  execute(p: ListMateriaisParams): Promise<MaterialApoio[]> { return this.g.list(p); }
}
export class CreateMaterial implements CreateMaterialUseCase {
  constructor(private readonly g: MaterialApoioGateway) {}
  execute(cmd: UpsertMaterialApoioCommand): Promise<MaterialApoio> { return this.g.create(cmd); }
}
export class UpdateMaterial implements UpdateMaterialUseCase {
  constructor(private readonly g: MaterialApoioGateway) {}
  execute(id: string, cmd: UpsertMaterialApoioCommand): Promise<MaterialApoio> { return this.g.update(id, cmd); }
}
export class ArquivarMaterial implements ArquivarMaterialUseCase {
  constructor(private readonly g: MaterialApoioGateway) {}
  execute(id: string): Promise<void> { return this.g.arquivar(id); }
}

export class ListManuais implements ListManuaisUseCase {
  constructor(private readonly g: ManualGateway) {}
  execute(p: ListManuaisParams): Promise<Manual[]> { return this.g.list(p); }
}
export class CreateManual implements CreateManualUseCase {
  constructor(private readonly g: ManualGateway) {}
  execute(cmd: UpsertManualCommand): Promise<Manual> { return this.g.create(cmd); }
}
export class UpdateManual implements UpdateManualUseCase {
  constructor(private readonly g: ManualGateway) {}
  execute(id: string, cmd: UpsertManualCommand): Promise<Manual> { return this.g.update(id, cmd); }
}
export class ArquivarManual implements ArquivarManualUseCase {
  constructor(private readonly g: ManualGateway) {}
  execute(id: string): Promise<void> { return this.g.arquivar(id); }
}

export class EnviarMensagem implements EnviarMensagemUseCase {
  constructor(private readonly g: MensagemGateway) {}
  execute(cmd: EnviarMensagemCommand): Promise<Mensagem> { return this.g.enviar(cmd); }
}
export class ListMensagensByAluno implements ListMensagensByAlunoUseCase {
  constructor(private readonly g: MensagemGateway) {}
  execute(alunoId: string): Promise<Mensagem[]> { return this.g.listByAluno(alunoId); }
}
